import { Typography } from "antd"
import type { ColumnType } from "antd/es/table/interface"

import { RecordRef } from "../../../../components/RecordRef.tsx"
import { RECORD_ID_LABEL } from "../../../../constants/record-ref.ts"
import { getEntityName } from "../../../../utils/user/get-entity-name"
import type { Lead } from "../../../Lead/types/lead.types.ts"
import { getActions } from "./columns-actions"

const { Text } = Typography

interface GetColumnsArgs {
  onSelectRow: (record: Lead, action: string) => void
  saving: boolean
}

export const getColumns = (args: GetColumnsArgs): ColumnType<Lead>[] => [
  {
    title: RECORD_ID_LABEL,
    dataIndex: "uid",
    key: "uid",
    width: 150,
    render: (uid: string | null) => <RecordRef uid={uid} compact />
  },
  {
    title: "Lead Name",
    dataIndex: "lead_name",
    key: "lead_name"
  },
  {
    title: "Customer Name",
    dataIndex: "customer",
    key: "customer",
    render: (customer: Lead["customer"], record) =>
      getEntityName(customer || record?.temporary_customer)
  },
  {
    title: "Sales Name",
    dataIndex: "sales_manager",
    key: "sales_manager",
    render: (sales_manager: Lead["sales_manager"]) => {
      const managers = sales_manager?.map((m) => getEntityName(m))?.join(", ")

      return (
        <div className={"flex w-52"}>
          <Text ellipsis={{ tooltip: managers }}>{managers}</Text>
        </div>
      )
    }
  },
  // {
  //   title: "Date",
  //   dataIndex: "sent_date",
  //   key: "sent_date",
  //   render: (_) => dayjs(_).format(dateFormat)
  // },
  // {
  //   title: "Proposal Amount",
  //   dataIndex: "proposal_value",
  //   key: "proposal_value",
  //   render: (_) => `$${acc.format(_, 0, ",")}`
  // },
  getActions(args)
]
